import { __makeTemplateObject } from "tslib";
/**@jsx jsx */

import { css, jsx } from '@emotion/react';
import { useState, useEffect } from 'react';
import { View } from './View';
import { Texts } from './Texts';
import { useTheme } from './theme/Providers';

var WrapperMainStyle = function WrapperMainStyle(isMobile, marginBottom) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  margin-bottom: ", ";\n  z-index: 1;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  margin-bottom: ", ";\n  z-index: 1;\n"])), isMobile ? '1.875rem' : marginBottom ? '3.125rem' : '');
};

var tabContainerStyle = function tabContainerStyle(fullWidth, justify) {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: ", ";\n    align-items: start;\n    flex-direction: row;\n    padding: 0.312rem;\n    @media (max-width: 767px) {\n      width: 100%;\n      justify-content: ", ";\n    }\n    ", "\n  "], ["\n    display: flex;\n    justify-content: ", ";\n    align-items: start;\n    flex-direction: row;\n    padding: 0.312rem;\n    @media (max-width: 767px) {\n      width: 100%;\n      justify-content: ", ";\n    }\n    ", "\n  "])), justify, justify === 'flex-start' ? 'flex-start' : 'center', fullWidth ? 'width: 100%' : null);
};

var tabTextStyle = function tabTextStyle(selected, theme) {
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  cursor: pointer;\n  transition: all .2s ease-out;\n  position: relative;\n  padding: 0 0 0.285rem;\n  margin: 0.571rem 0.857rem 0 0.857rem;\n  @media (max-width: 767px) {\n      font-size: 10px;\n  }\n  ", "\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  cursor: pointer;\n  transition: all .2s ease-out;\n  position: relative;\n  padding: 0 0 0.285rem;\n  margin: 0.571rem 0.857rem 0 0.857rem;\n  @media (max-width: 767px) {\n      font-size: 10px;\n  }\n  ", "\n"])), selected ? '#4D5CDD' : theme.colors.scales.grayShades[5], selected ? theme.fontWeights.heading : theme.fontWeights.body, selected ? "&:after {\n    position: absolute;\n    content: '';\n    height: 2px;\n    bottom: 0px;\n    border-radius:4rem;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    width: 50%;\n    background: #4D5CDD;\n    transition:.5s;\n   }" : null);
};

var defaultContentStyle = function defaultContentStyle() {
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 100%;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 1rem;\n"], ["\n    width: 100%;\n    max-width: 100%;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 1rem;\n"])));
};

var Tabs = function Tabs(_a) {
  var tabs = _a.tabs,
      _b = _a.initialTab,
      initialTab = _b === void 0 ? null : _b,
      _c = _a.fullWidth,
      fullWidth = _c === void 0 ? false : _c,
      _d = _a.justify,
      justify = _d === void 0 ? 'space-around' : _d,
      isMobile = _a.isMobile,
      _e = _a.marginBottom,
      marginBottom = _e === void 0 ? true : _e,
      simulador = _a.simulador,
      _f = _a.render,
      render = _f === void 0 ? function (content) {
    return jsx(View, {
      css: defaultContentStyle
    }, content);
  } : _f;
  var theme = useTheme();

  var _g = useState(0),
      current = _g[0],
      setCurrent = _g[1];

  var _h = useState(null),
      currentContent = _h[0],
      setCurrentContent = _h[1];

  var setContent = function setContent(index, tab, init) {
    if (init === void 0) {
      init = false;
    }

    setCurrent(index);

    if (tab) {
      if (tab.content) setCurrentContent(tab.content);else setCurrentContent(null);
      if (tab.handleClick && !init) tab.handleClick();
    }
  };

  useEffect(function () {
    if (tabs.length) {
      setContent(initialTab, initialTab !== null ? tabs[initialTab] : null, true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [tabs]);
  return jsx(View, {
    id: 'tabsContainer',
    css: WrapperMainStyle(isMobile, marginBottom)
  }, jsx(View, {
    css: tabContainerStyle(fullWidth, justify)
  }, tabs.map(function (tab, index) {
    return jsx(Texts, {
      weight: 'bold',
      size: 'medium',
      key: index,
      css: tabTextStyle(current === index, theme),
      onClick: function onClick() {
        return setContent(index, tab);
      },
      variant: simulador ? 'caption' : 'label'
    }, tab.title);
  })), currentContent ? render(currentContent) : null);
};

export { Tabs };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;